<template>
  <div class="input-switch">
    <label class="flex cursor-pointer items-center space-x-2" v-bind="$attrs">
      <SwitchRoot
        v-model="modelValue"
        :class="modelValue ? stateOnClass : stateOffClass"
        class="pointer-events-auto relative inline-flex w-11 cursor-pointer items-center rounded-full py-1"
        :tabindex="tabindex"
        @click.left.stop="onInput"
        @keyup.space="onInput"
      >
        <SwitchThumb
          :class="modelValue ? 'translate-x-6' : 'translate-x-1'"
          class="surface inline-block size-4 transform rounded-full transition"
        />
      </SwitchRoot>
      <span v-if="$slots.default" class="whitespace-nowrap select-none">
        <slot />
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { SwitchRoot, SwitchThumb } from "reka-ui"
import { nextTick } from "vue"

defineProps({
  stateOnClass: {
    type: String,
    required: false,
    default: "bg-secondary focus:outline-primary focus:outline"
  },
  stateOffClass: {
    type: String,
    required: false,
    default: "bg-gray-lighten-1 focus:outline-secondary  focus:outline"
  },
  tabindex: {
    type: Number,
    required: false,
    default: 0
  }
})

const modelValue = defineModel<boolean>({ required: true, default: false })

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(["change"])

function onInput() {
  nextTick(() => {
    // Wrap in nextTick because @change precedes the modelValue update.
    emit("change", modelValue.value)
  })
}
</script>

<style scoped></style>
